import React, {ReactNode, ReactNodeArray, useEffect} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadMarketPriceData from '../../../Models/Content/AbroadMarketPriceBlockData';
import AbroadMarketPriceMain from '../AbroadMarketPriceBlock/AbroadMarketPriceMain';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import { isBrowser, isMobile } from "react-device-detect";


export default class AbroadMarketPrice extends EpiComponent<AbroadMarketPriceData>
{
    constructor(props) {
        super(props);  
    }

    public render() : ReactNode | ReactNodeArray | null
    {
        const context = this.getContext();
        const iContent = this.props.data;

        return (
            <AbroadMarketPriceMain context={context} iContent={iContent}></AbroadMarketPriceMain>    
        );
    }
}
